<template>
  <div class="webs_container">
    <NavBar :title="title"/>
    <div class="webs_content_bz" v-if="type == 1">
      <img src="../../assets/img/one.png" alt="" class="bz_img">
    </div>

    <div class="webs_content_bz" v-if="type == 2">
      <img src="../../assets/img/jbcx.jpg" alt="" class="bz_img">
    </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
          type:0,
          title:'标题'
        }
    },
    created(){
      this.type = this.$route.query.type
      if(this.type == 1){
        this.title='举报奖励标准'
      }else if(this.type == 2){
        this.title='举报方式查询'
      }
			document.title=this.title
			
    },
    methods:{

    }
};
</script>


<style lang="less" scoped>
  .webs_container{
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
  }
  .webs_content_bz{
    width: 100%;
    position: absolute;
    left: 0;
    top: 50px;
		bottom: 0;
		overflow-x: hidden;
    overflow-y: scroll;
  }
  .bz_img{
    width: 100%;
    height: auto;
		display: block;
		max-width: 960px;
		margin: 0px auto;
  }
</style>
